<template>
  <OnofficeActivation marketplace-integration="APP">
    <template v-slot:description>
      {{ $t('crm.on-office-activation-app.description') }}
    </template>
    <template v-slot:success>
      <b>{{ $t('crm.on-office-activation-app.success.title') }}</b
      ><br />
      {{ $t('crm.on-office-activation-app.success.message') }}
    </template>
  </OnofficeActivation>
</template>

<script>
import OnofficeActivation from './OnofficeActivation.vue'

export default {
  components: { OnofficeActivation },
}
</script>
